module.exports = __webpack_public_path__ + "2e34b4fe5a28ff39d001619938fbeb7f.png";